import {formatData} from '@/utils/util'
import moment from 'moment'

export const IS_ABNORMAL={
  ABNORMAL:true,
  NOT_ABNORMAL:false
}
const ABNORMAL_TYPE={
  ABNORMAL:'异常',
  NOT_ABNORMAL:'无异常'
}
export const SearchFiled=[
  {
    label:'日期范围',
    name:'createTime',
    type:'date',
    prop:{
      showTime:{
        format: "HH:mm:ss",
        defaultValue: [
        moment("00:00:00", "HH:mm:ss"),
        moment("23:59:59", "HH:mm:ss"),
        ],
      },
      format:"YYYY-MM-DD",
      placeholder: ['开始日期', '结束日期'],
    },
  },
  {
    label:'货品编码',
    name:'goodsCode',
    type:'input',
    prop:{
      placeholder: '请输入货品编码',
      maxLength:100
    },
  },
  {
    label:'商品名称',
    name:'goodsName',
    type:'input',
    prop:{
      placeholder: '请输入商品名称',
      maxLength:100
    },
  },
  {
    label:'批次',
    name:'batchNo',
    type:'input',
    prop:{
      placeholder: '请输入批次',
      maxLength:100
    },
  },
  {
    label:'是否异常',
    name:'abnormal',
    type:'select',
    prop:{
      placeholder: '请选择状态',
      allowClear:true,
      options:formatData({'':'全部',...ABNORMAL_TYPE})
    },
  },
]

export const TableColumns=[
  {
    title: '序号',
    dataIndex: 'index',
    customRender: (text,row,index) => index+1,
    width: 60,
  },
  {
    title: '货品编码',
    dataIndex: 'shipperGoodsCode',
    key: 'shipperGoodsCode',
    scopedSlots: { customRender: 'shipperGoodsCode' },
    ellipsis: true,
    width: 140,
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    scopedSlots: { customRender: 'goodsName' },
    ellipsis: true,
    width: 180,
  },
  {
    title: '默认单位',
    dataIndex: 'defaultUnit',
    key: 'defaultUnit',
    width: 80,
  },
  {
    title: '批次号',
    dataIndex: 'batchNo',
    key: 'batchNo',
    scopedSlots: { customRender: 'batchNo' },
    ellipsis: true,
    width: 180,
  },
  {
    title: '期初库存',
    dataIndex: 'beginStock',
    key: 'beginStock',
    width: 120,
  },
  {
    title: '期初总重',
    dataIndex: 'beginWeight',
    key: 'beginWeight',
    width: 120,
  },
  {
    title: '入库量',
    dataIndex: 'inBoundAmount',
    key: 'inBoundAmount',
    width: 120,
  },
  {
    title: '入库总重',
    dataIndex: 'inBoundWeight',
    key: 'inBoundWeight',
    width: 120,
  },
  {
    title: '出库量',
    dataIndex: 'outBoundAmount',
    key: 'outBoundAmount',
    width: 120,
  },
  {
    title: '出库总重',
    dataIndex: 'outBoundWeight',
    key: 'outBoundWeight',
    width: 120,
  },
  {
    title: '调整量',
    dataIndex: 'adjustAmount',
    key: 'adjustAmount',
    width: 120,
  },
  {
    title: '调整总量',
    dataIndex: 'adjustWeight',
    key: 'adjustWeight',
    width: 120,
  },
  {
    title: '期末库存',
    dataIndex: 'endStock',
    key: 'endStock',
    width: 120,
  },
  {
    title: '期末总重',
    dataIndex: 'endWeight',
    key: 'endWeight',
    width: 120,
  },
  {
    title: '是否异常',
    dataIndex: 'abnormal',
    key: 'abnormal',
    width: 120,
  },
  {
    title: '周转率',
    dataIndex: 'turnoverRate',
    key: 'turnoverRate',
    width: 120,
  },
  {
    title: '周转天数',
    dataIndex: 'turnoverDay',
    key: 'turnoverDay',
    width: 120,
  },
  {
    title: '库龄<60天库存量(吨)',
    dataIndex: 'stockAgeOne',
    key: 'stockAgeOne',
    width: 160,
  },
  {
    title: '60≤库龄<90天库存量(吨)',
    dataIndex: 'stockAgeTwo',
    key: 'stockAgeTwo',
    width: 180,
  },
  {
    title: '库龄≥90天库存量(吨)',
    dataIndex: 'stockAgeThree',
    key: 'stockAgeThree',
    width: 160,
  },
]

